import { useEffect, useState } from 'react'

/**
 * The current time, re-rendering the caller every `stepMs` on the boundary
 * (so a 30s step ticks at :00 and :30) and whenever the tab becomes visible
 * again — a laptop waking from sleep shows the right "now" straight away.
 * Deriving "today" from it rolls pages over at midnight without a reload.
 */
export function useNow(stepMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    let timer = 0
    const schedule = () => {
      timer = window.setTimeout(() => { setNow(new Date()); schedule() }, stepMs - (Date.now() % stepMs))
    }
    const onVisible = () => { if (!document.hidden) setNow(new Date()) }
    schedule()
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      window.clearTimeout(timer)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [stepMs])
  return now
}
